import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AppHeader from "@/components/feature/AppHeader";
import AppFooter from "@/components/feature/AppFooter";
import HelpHero from "@/pages/help/components/HelpHero";
import QuickStart from "@/pages/help/components/QuickStart";
import FaqSection from "@/pages/help/components/FaqSection";
import GuideLibrary from "@/pages/help/components/GuideLibrary";
import SupportTicket from "@/pages/help/components/SupportTicket";
import { CATEGORY_ISSUE_TYPE } from "@/pages/help/faqData";

export default function HelpCenterPage() {
  const location = useLocation();
  const [ticketPrefill, setTicketPrefill] = useState<{ type: string; nonce: number }>({ type: "", nonce: 0 });

  useEffect(() => {
    if (!location.hash || location.hash.startsWith("#faq-item-")) return;
    const target = document.querySelector(location.hash);
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  }, [location.hash]);

  const handleFaqNotHelpful = (categoryId: string) => {
    const type = CATEGORY_ISSUE_TYPE[categoryId] ?? "";
    setTicketPrefill((prev) => ({ type, nonce: prev.nonce + 1 }));
    window.setTimeout(() => {
      document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
    }, 60);
  };

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <AppHeader />
      <main className="flex-1">
        <HelpHero />
        <QuickStart />
        <FaqSection onNotHelpful={handleFaqNotHelpful} />
        <GuideLibrary />
        <SupportTicket prefillIssueType={ticketPrefill.type} prefillNonce={ticketPrefill.nonce} />
      </main>
      <AppFooter />
    </div>
  );
}